module.exports = __webpack_public_path__ + "media/images/common/top_content_bg-491ef5090112035b9cc6606ff1046f9a.png";